import React from "react";
import TicketHeader from "./TicketHeader";
import FaqsList from "./FaqsList";

const SupportFaqs = () => {
  return (
    <>
      <TicketHeader />
      <FaqsList />
    </>
  );
};

export default SupportFaqs
